// Read-only mirror of the `data-compact` attribute set on <html> by
// the measured collapse trigger in App.tsx. Any component that wants
// to react to "compact mode" from JavaScript (rather than CSS) imports
// `isCompact()` from here. The attribute itself remains the source of
// truth — this module just keeps a Solid signal in sync via a single
// module-scope MutationObserver so reads are cheap and reactive.

import { createSignal } from "solid-js";

function read(): boolean {
  if (typeof document === "undefined") return false;
  return document.documentElement.dataset.compact === "true";
}

const [compact, setCompact] = createSignal<boolean>(read());

if (typeof document !== "undefined" && typeof MutationObserver !== "undefined") {
  const mo = new MutationObserver(() => setCompact(read()));
  mo.observe(document.documentElement, { attributes: true, attributeFilter: ["data-compact"] });
}

export function isCompact(): boolean {
  return compact();
}
